<script setup>
import {Head, useForm} from "@inertiajs/inertia-vue3";
import {computed, defineProps, onBeforeUnmount, onMounted, ref, watch} from "vue";
import useUtils from '../Composables/useUtils';
import AuditorioLayoutV2 from "../Layouts/AuditorioLayoutV2";
import {Notify, useQuasar} from "quasar";
import { Inertia } from "@inertiajs/inertia";
import useRotas from "../Composables/useRotas";
import { useModeradorStore } from "@/Stores/moderadorStore";
import useLote from "@/Composables/useLote";

const auditorioStore = useModeradorStore();

const route = useRotas();

const $q = useQuasar();

const props = defineProps({
    leilao: Object,
    loteSelecionadoInit: Object,
    lotesInit: Array,
});


const retryConnectSocket = ref(0);
const maxRetryConnectSocket = 5;

const isConnected = ref(false);
const onStateChange = (states) => {
    // states.current: 'initialized' | 'connecting' | 'connected' | 'unavailable' | 'failed' | 'disconnected'
    isConnected.value = (states.current === 'connected' || states.current === 'connecting' || states.current === 'initialized');
};
window.Echo.connector.pusher.connection.bind('state_change', onStateChange);


const lanceLocal = ref(false);

const idLoteSelecionado = computed(() => auditorioStore.idLoteSelecionadoLeilao[props.leilao.id]);
const lote = computed(() => auditorioStore.lotes[idLoteSelecionado.value]);
const loteSelecionadoAuditorio = computed(() => auditorioStore.lotes[idLoteSelecionado.value]);
const qtdLances = computed(() => {
    return loteSelecionadoAuditorio.value?.lances?.length || 0;
});

const leilaoSelecionadoAuditorio = computed(() => auditorioStore.leiloes[props.leilao.id]);

const valorLanceAtual = computed(() => {
    return loteSelecionadoAuditorio?.value?.lanceAtual;
});

const valorLanceAtualLances = computed(() => {
    return loteSelecionadoAuditorio?.value?.lances?.[0]?.valor;
});

const { autoplay, slide, timerModerador } = useLote(
    leilaoSelecionadoAuditorio.value,
    lote
);

const {
    formatDate,
    formatador,
    formatadorLote,
    getImagem
} = useUtils();

let leiloeiroAndou = (e) => {
    abrirLoteAuditorio(e.id);

    setTimeout(() => {
        document.querySelector('.list-parent').scrollLeft = document.querySelector('.list-parent > .atual').offsetLeft - 20
    }, 800);
};

let leiloeiroMudouLeilao = async (e) => {
    if (+leilaoSelecionadoAuditorio.value?.id === +e.idLeilaoAnterior) {

        location.href = route('moderador.lei.lote', {
            idLeilao: e.idLeilao
        });

    }

};

let callbackStatus = (e) => {
    auditorioStore.enfileirar(e);
}

let callbackUpdate = (e) => {
    auditorioStore.enfileirar(e);
}

const conexaoWebSocket = ref(0);

onMounted(async () => {

    conexaoWebSocket.value = setInterval(() => {
        if(!isConnected.value){
            if (retryConnectSocket.value < maxRetryConnectSocket) {
                retryConnectSocket.value++;
                console.log(`Tentativa de reconexão ${retryConnectSocket.value} de ${maxRetryConnectSocket}`);
                window.Echo.connector.pusher.connect();
            } else {
                Notify.create({
                    message: 'Não foi possível conectar ao servidor de leilões. Por favor, verifique sua conexão com a internet.',
                    icon: 'mdi-alert-circle',
                    color: 'negative',
                    progress: true,
                    timeout: 10000,
                    group: 'erro-conexao'
                });
            }
        }
    }, 15000);

    $q.loading.show({
        message:
            "<p>Carregando Leiloeiro</p>",
        html: true,
    });
    setTimeout(() => {
        $q.loading.hide();
    }, 3000);

    await auditorioStore.carregamentoLeilaoInicial(props.leilao.id);
    await auditorioStore.carregamentoLotesInicial(props.leilao.id);

    if(!idLoteSelecionado.value){
        await abrirLoteAuditorio(props.loteSelecionadoInit.id);
    }

    auditorioStore.processarFila()

    window.Echo.channel("realtime.status.leilao").listen(
        ".leilao." + props.leilao.id + ".status.atualizado",
        (e) => {
            callbackStatus(e);
        }
    );

    window.Echo.channel("realtime.update.leilao").listen(
        ".leilao." + props.leilao.id + ".atualizado",
        (e) => {
            callbackUpdate(e);
        }
    );

    window.Echo.channel("auditorio." + props.leilao.id).listen(
        ".leiloeiroAndou",
        (e) => {
            leiloeiroAndou({ id: e.novoLote, dados: e.dadosNovoLote });
        }
    );

    window.Echo.channel("auditorio").listen(".leiloeiroMudouLeilao", (e) => {
        leiloeiroMudouLeilao({
            idLeilao: e.novoLeilao,
            idLeilaoAnterior: e.leilaoAnterior,
        });
    });

    window.Echo.channel('realtime.mensagemGlobal.somenteModerador').listen('.notificacao', (e) => {

        Notify.create({
            message: e.mensagem,
            icon: e.icone,
            color: e.cor,
            progress: true,
            group: e.grupo ? e.grupo : undefined
        });

    });


});


watch(isConnected, (newVal) => {

    if(newVal === false){

            Notify.create({
                message: 'Servidor websocket desconectado. Tentando reconectar...',
                icon: 'mdi-alert-circle',
                color: 'warning',
                progress: true,
                timeout: 10000,
                group: 'erro-conexao'
            });

    } else {

        abrirLoteAuditorio(idLoteSelecionado.value);

        retryConnectSocket.value = 0; // Reseta a contagem de tentativas ao conectar com sucesso
        Notify.create({
            message: 'Conectado ao servidor de leilões.',
            icon: 'mdi-check-circle',
            color: 'positive',
            progress: true,
            timeout: 5000,
            group: 'sucesso-conexao'
        });
    }

});

const urlVideo = computed(() => {
    return leilaoSelecionadoAuditorio.value?.link_transmissao
        ? `${leilaoSelecionadoAuditorio.value?.link_transmissao}`
        : null;
});

const abrirLoteAuditorio = (idLote) => {

    auditorioStore.carregamentoLoteMomentoInicial(leilaoSelecionadoAuditorio.value?.id,idLote);
    slide.value = 1; // volta a imagem para a primeira

    lanceLocal.value = false;


    window.Echo.channel('realtime.status.lote')
        .listen('.lote.' + idLote + '.status.atualizado', (e) => {
            callbackStatus(e);
        });

    window.Echo.channel('realtime.update.lote')
        .listen('.lote.' + idLote + '.atualizado', (e) => {
            callbackUpdate(e);
        });

};

const valorLanceAuditorio = ref(0);

const voltarPaginaLeilao = () => {
    Inertia.visit(route('leilao', {
        idLeilao: leilaoSelecionadoAuditorio.value?.id
    }));
}

const decodeHtmlEntities = (text) => {
    const entities = {
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&amp;": "&",
    };
    return text.replace(/&lt;|&gt;|&quot;|&amp;/g, (match) => entities[match]);
};
const replaceHmtlIframe = (encodedHtml) => {
    let decodedHtml = encodedHtml;

    if (decodedHtml && decodedHtml.length > 0) {
        const arrayRegex = [
            /&lt;iframe\s+src="https:\/\/www\.google\.com\/maps\/embed[^"]*"[^&]*&gt;&lt;\/iframe&gt;/g,
            /&lt;iframe[^>]*\bsrc="https:\/\/www\.youtube\.com\/embed\/[^"]*"[^>]*&gt;&lt;\/iframe&gt;/g,
        ];

        arrayRegex.forEach((e) => {
            decodedHtml = decodedHtml.replace(e, (match) =>
                decodeHtmlEntities(match)
            );
        });
    }

    return decodedHtml;
};

const descricaoLote = computed(() => replaceHmtlIframe(loteSelecionadoAuditorio.value?.descricao));

watch([valorLanceAtual, valorLanceAtualLances], ([newValorLanceAtual], [oldValorLanceAtual]) => {

    if(newValorLanceAtual !== oldValorLanceAtual){
        valorLanceAuditorio.value = +loteSelecionadoAuditorio?.value?.proximoLance;
        formLancePresencial.valorPresencial = formatador.format(loteSelecionadoAuditorio?.value?.proximoLance);
    }

});


const incrementoLocal = ref( 0);
const lanceInicialLocal = ref(0);
const lanceMinimoLocal = ref(0);


const formLancePresencial = useForm({
    identificacaoPresencial: null,
    valorPresencial: 0,
});


const mudaCorLance = ref(false);

watch(
    () => loteSelecionadoAuditorio?.value?.lances,
    (novo, antigo) => {

        if (novo?.[0]?.id_lote === antigo?.[0]?.id_lote &&
            novo?.[0]?.id !== antigo?.[0]?.id) {

            mudaCorLance.value = true;

            // Restaura a cor da div após 2 segundos
            setTimeout(() => {
                mudaCorLance.value = false;
            }, 2000);

        }
    }
);


watch(loteSelecionadoAuditorio, (newValue) => {

    incrementoLocal.value = newValue?.incremento * 100;
    lanceInicialLocal.value = leilaoSelecionadoAuditorio?.value?.primeiro_leilao_concluido === 1 &&
    +leilaoSelecionadoAuditorio?.value?.dois_leiloes === 1
        ? newValue?.lance_inicial_segundo_leilao * 100
        : newValue?.lance_inicial * 100;
    lanceMinimoLocal.value = newValue?.lance_minimo
        ? newValue?.lance_minimo * 100
        : lanceInicialLocal.value;

});

onBeforeUnmount(() => {
    auditorioStore.pararFila();
    leiloeiroAndou = () => {};
    leiloeiroMudouLeilao = () => {};

    callbackStatus = () => {};
    callbackUpdate = () => {};
    auditorioStore.redefinirLoteSelecionado(props.leilao.id);

    clearInterval(conexaoWebSocket.value);
    conexaoWebSocket.value = 0;

});

</script>
<template>
    <Head :title="'Auditorio - ' + loteSelecionadoAuditorio?.titulo" />
    <AuditorioLayoutV2>
        <q-page class="flex column bg-grey-3">
            <div class="full-width flex row justify-between items-center bg-primary" style="border-bottom: 5px solid rgb(194, 0, 11); height: 50px;">
                <div class="flex row full-height items-center">
                    <div class="flex q-px-md text-white">
                        <q-btn outline size="sm" class="q-mr-sm" @click="voltarPaginaLeilao">
                            <q-icon name="mdi-arrow-left" />
                        </q-btn>
                    </div>
                    <div class="text-white text-subtitle2" :class="$q.screen.gt.xs ? '' : 'text-subtitle2'" >
                        <template v-if="leilaoSelecionadoAuditorio">
                            <div class="flex">
                                Data: {{ formatDate(leilaoSelecionadoAuditorio?.data_hora_inicio) }}
                            </div>
                            <div class="flex" :style="$q.screen.lt.lg ? 'max-width: 400px;' : 'max-width: 60vw;'"
                                 style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: inline-block;">
                                Leilão:
                                {{ leilaoSelecionadoAuditorio?.id }}
                                <template v-if="$q.screen.gt.sm">

                                    "{{
                                        leilaoSelecionadoAuditorio?.titulo
                                    }}"

                                </template>
                            </div>
                        </template>
                    </div>

                </div>

                <div class="full-height q-mr-md flex row justify-center items-center text-white">

                    <div class="q-pa-xs flex row items-center">

                        <template v-if="!isConnected && retryConnectSocket > maxRetryConnectSocket"> <q-icon name="mdi-circle" size="30px" class="text-red"/></template>
                        <template v-else-if="isConnected"> <q-icon name="mdi-circle" size="30px" class="text-white"/></template>
                        <template v-else><q-icon name="mdi-circle" size="30px" class="text-yellow"/></template>


                    </div>

                </div>
            </div>

            <div class="col-12 row bg-grey-3" >

                <div class="flex row full-width" :style="$q.screen.lt.md ? 'flex-direction: column-reverse' : '' ">
                    <div class="bg-grey-3 row column q-py-sm q-pl-sm q-pr-none"
                         :class="$q.screen.lt.md ? 'col-12' : 'col-8' "
                    >
                        <div class="col-12 row">

                            <div class="bg-gray-3 q-pr-sm  " :class="$q.screen.lt.md ? 'col-12' : 'col-6'">

                                <div class="col-12 column">
                                    <div class="row col-12" style="height: 20vh" >
                                        <div class="col-6 q-pr-xs">
                                            <q-card  style="height: 20vh">

                                                <q-card-section class="q-pa-none q-mb-xs flex row fit q-pa-sm">
                                                    <q-carousel
                                                        class="override-index full-width"
                                                        v-model="slide"
                                                        :autoplay="false"
                                                        animated
                                                        arrows

                                                        control-color="white"
                                                        control-text-color="primary"
                                                        control-type="push"
                                                        next-icon="mdi-chevron-right"
                                                        prev-icon="mdi-chevron-left"
                                                        infinite
                                                        swipeable
                                                        :class="$q.screen.gt.sm ? 'col-5' : 'col-12'"
                                                        @mouseenter="autoplay = false"
                                                        @mouseleave="autoplay = true"
                                                    >
                                                        <q-carousel-slide
                                                            v-for="(imagem, key) in lote?.imagens_lote &&
                                loteSelecionadoAuditorio?.imagens_lote.length > 0
                                    ? loteSelecionadoAuditorio?.imagens_lote
                                    : leilaoSelecionadoAuditorio?.comitente?.arquivo_capa_padrao
                                    ? [
                                          {
                                              arquivo:
                                                  leilaoSelecionadoAuditorio?.comitente?.arquivo_capa_padrao,
                                          },
                                      ]
                                    : []"
                                                            :key="key"
                                                            :name="
                                    1 + key
                                "
                                                            style="
                                    background-position: center;
                                    background-size: cover;
                                    background-repeat: no-repeat;
                                "
                                                            class="q-pa-none"
                                                        >
                                                            <q-img
                                                                class="full-width full-height"
                                                                loading="lazy"
                                                                :src="
                                        getImagem(
                                            imagem?.arquivo,
                                            true,
                                            loteSelecionadoAuditorio?.status_lote?.identificador
                                        )
                                    "
                                                                :ratio="16 / 9"
                                                            >
                                                                <template v-slot:error>
                                                                    <div
                                                                        class="absolute-full flex flex-center bg-primary text-white"
                                                                    >
                                                                        Houve um problema carregando a imagem
                                                                    </div>
                                                                </template>
                                                                <template v-slot:loading>
                                                                    <div
                                                                        class="absolute-full flex column flex-center bg-white text-primary"
                                                                    >

                                                                        <p class="q-mt-sm">
                                                                            <q-spinner size="sm" class="q-pr-sm" />
                                                                            Carregando imagem...
                                                                        </p>
                                                                    </div>
                                                                </template>
                                                            </q-img>
                                                        </q-carousel-slide>
                                                    </q-carousel>
                                                </q-card-section>

                                            </q-card>
                                        </div>

                                        <div class="col-6 q-pl-xs">
                                            <q-card  style="height: 20vh">
                                                <KeepAlive :key="urlVideo">
                                                    <div class="col-4"  v-if="urlVideo" v-show="+leilaoSelecionadoAuditorio?.transmissao_iniciada === 1">

                                                            <q-card-section>
                                                                <q-video

                                                                    :ratio="16/9"
                                                                    :src="urlVideo"
                                                                />
                                                            </q-card-section>

                                                    </div>
                                                </KeepAlive>
                                            </q-card>

                                        </div>
                                    </div>
                                    <div class="col-12 q-mt-sm bg-yellow" >
                                        <q-card style="height: 60vh;">
                                            <q-card-section class="q-pa-none q-mb-xs flex row full-height" >
                                                <iframe
                                                    v-show="leilaoSelecionadoAuditorio?.chat_url_evento"
                                                    :src="leilaoSelecionadoAuditorio?.chat_url_evento ? `${leilaoSelecionadoAuditorio?.chat_url_evento}&remover_chat=0` : 'about:blank'"
                                                    style="width: 100%; height: 100%; border: none"
                                                ></iframe>
                                            </q-card-section>
                                        </q-card>
                                    </div>
                                </div>


                            </div >

                            <!-- 3 -->
                            <div class="bg-grey-3" :class="$q.screen.lt.md ? 'col-12' : 'col-6'">
                                <q-card class="q-mt-none q-pa-md" style="min-height: 80vh;">
                                    <div class="text-primary text-subtitle1">Lote nº {{ formatadorLote(+loteSelecionadoAuditorio?.sequencia) }}</div>
                                    <div class="text-primary text-h6">{{ loteSelecionadoAuditorio?.titulo }}</div>
                                    <q-separator class="q-my-md"/>
                                    <div class="text-primary">Descrição:</div>
                                    <div v-html="descricaoLote"> </div>
                                </q-card>
                            </div>


                        </div>

                    </div>

                    <div class="bg-grey-3 q-pa-sm"
                         :class="$q.screen.lt.md ? 'col-12' : 'col-4' ">
                        <div class="col-12 q-mb-sm" v-if="loteSelecionadoAuditorio?.sequencia && $q.screen.lt.md">
                            <q-card>
                                <q-card-section class="text-center text-subtitle1 text-primary">
                                    Lote nº {{ formatadorLote(+loteSelecionadoAuditorio?.sequencia || 0 )  }}
                                </q-card-section>
                            </q-card>
                        </div>



                        <div class="col-12" v-if="+leilaoSelecionadoAuditorio?.fechamento_automatico === 0 &&
                                loteSelecionadoAuditorio?.timer_moderador && timerModerador">
                            <q-card class="q-mt-sm text-primary"

                            >
                                <q-card-section>
                                    <div class="text-h6 text-center"><q-icon name="mdi-timer" color="primary" size="sm" class="q-mr-md"/>{{timerModerador}}</div>
                                </q-card-section>
                            </q-card>
                        </div>
                        <div class="col-12 ">
                            <q-card
                                :style="`background-color: ${loteSelecionadoAuditorio?.status_lote?.cor_site};`"
                                style="color: white;"
                            >
                                <q-card-section class="q-ma-none q-pa-xs">
                                    <div class="text-h6 text-center">{{loteSelecionadoAuditorio?.status_lote?.nome}}</div>
                                </q-card-section>
                            </q-card>
                        </div>
                        <div class="col-12" >
                            <q-card class="q-mt-sm">
                                <q-card-section class="text-center"
                                                :class="{
                                                    'bg-positive': mudaCorLance,
                                                    'blink': mudaCorLance,
                                                }"

                                >
                                    <div class="text-subtitle3">
                                        Lance Atual
                                    </div>
                                    <div class="text-h3 text-primary text-bold">{{formatador.format(loteSelecionadoAuditorio?.lances?.[0]?.valor || valorLanceAtual)}}</div>
                                      <div class="text-subtitle3" v-if="loteSelecionadoAuditorio?.lances?.[0]">
                                        Por {{ loteSelecionadoAuditorio?.lances?.[0]?.cliente?.usuario?.username }}

                                        <template
                                            v-if="loteSelecionadoAuditorio?.lances?.[0]?.cliente?.enderecos_cliente?.length > 0"
                                        >
                                            de

                                            {{
                                                loteSelecionadoAuditorio?.lances?.[0]?.cliente?.enderecos_cliente?.[0]?.rua?.bairro?.cidade?.nome ||
                                                loteSelecionadoAuditorio?.lances?.[0]?.cliente?.enderecos_cliente?.[0]?.cidade_endereco
                                            }}
                                            /
                                            {{
                                                loteSelecionadoAuditorio?.lances?.[0]?.cliente?.enderecos_cliente?.[0]?.rua?.bairro?.cidade?.estado?.codigo_uf ||
                                                loteSelecionadoAuditorio?.lances?.[0]?.cliente?.enderecos_cliente?.[0]?.uf_endereco
                                            }}
                                        </template>

                                    </div>
                                </q-card-section>

                                <q-card-section class="text-center q-py-none"
                                                :class="{
                                                    'bg-positive': mudaCorLance,
                                                    'blink': mudaCorLance,
                                                }"

                                >
                                    <div class="text-subtitle3 ">
                                        Próximo Lance
                                    </div>

                                    <div class="text-h6 text-primary text-bold">{{formatador.format(loteSelecionadoAuditorio?.proximoLance)}}</div>

                                </q-card-section>

                                <q-card-section class="text-center"
                                                :class="{
                                                    'bg-positive': mudaCorLance,
                                                    'blink': mudaCorLance,
                                                }"

                                >
                                    <div class="text-subtitle3">
                                        Incremento
                                    </div>

                                    <div class="text-h6 text-primary">{{formatador.format(loteSelecionadoAuditorio?.incremento)}}</div>

                                </q-card-section>

                            </q-card>
                        </div>

                        <div class="col-12">
                            <q-card class="q-mt-sm">
                                <q-card-section>
                                    <div class="text-subtitle1 text-primary">Últimos Lances</div>
                                </q-card-section>
                                <q-card-section v-if="!(+loteSelecionadoAuditorio?.lances?.length > 0)" style="font-size: 10px;">
                                    Nenhum lance registrado.
                                </q-card-section>
                                <q-card-section class="q-pt-none" v-else>
                                    <q-scroll-area
                                        class="full-width"
                                        style="height: 350px; "
                                    >
                                        <div class="q-pa-none full-width" >
                                            <q-markup-table>
                                                <thead>
                                                <tr style="height: auto;">
                                                    <th class="text-left text-bold" style="height: auto; font-size: 10px;">Lance</th>
                                                    <th class="text-left text-bold" style="height: auto; font-size: 10px;">Apelido</th>
                                                    <th class="text-left text-bold" style="height: auto; font-size: 10px;">Valor</th>
                                                </tr>
                                                </thead>
                                                <tbody>

                                                <tr v-for="(lance, idx) in loteSelecionadoAuditorio?.lances" :key="idx" style="height: auto;">
                                                    <td class="text-left" style="height: auto; font-size: 10px;">{{ (+qtdLances - +idx) }}</td>
                                                    <td class="text-left" style="height: auto; font-size: 10px;">{{lance?.cliente?.usuario?.username}} <br/> em {{formatDate(lance?.data_hora)}}
                                                    <br/>

                                                        <template
                                                            v-if="lance?.cliente?.enderecos_cliente?.length > 0"
                                                        >
                                                            {{
                                                                lance?.cliente?.enderecos_cliente?.[0]?.rua?.bairro?.cidade?.nome ||
                                                                lance?.cliente?.enderecos_cliente?.[0]?.cidade_endereco
                                                            }}
                                                            /
                                                            {{
                                                                lance?.cliente?.enderecos_cliente?.[0]?.rua?.bairro?.cidade?.estado?.codigo_uf ||
                                                                lance?.cliente?.enderecos_cliente?.[0]?.uf_endereco
                                                            }}
                                                        </template>

                                                    </td>
                                                    <td class="text-left" style="height: auto; font-size: 10px;">{{ formatador.format(lance?.valor) }}
                                                        <br/>
                                                        <template v-if="lance?.id_lance_automatico_registrado">
                                                            Automático
                                                        </template>
                                                        <template v-else>
                                                            Manual
                                                        </template>
                                                    </td>
                                                </tr>

                                                </tbody>
                                            </q-markup-table>
                                        </div>
                                    </q-scroll-area>
                                </q-card-section>

                            </q-card>
                        </div>

                    </div>
                </div>
            </div>

        </q-page>
    </AuditorioLayoutV2>
</template>
<style scoped>

::-webkit-scrollbar {
    right: 0;
    border-radius: 5px;
    background-color: transparent;
    height: 10px;
    opacity: 0.5;
}

::-webkit-scrollbar-thumb {
    cursor: pointer;
    border-radius: 9px;
    background: rgba(0, 0, 0, 0.15);
}

.blink {
    animation: blink 1s steps(1, end) 3s;
}

@keyframes blink {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

</style>
